export function getDisplayName(u) {
  if (!u) return "";
  const isSeller = u.role === "seller";
  if (isSeller) {
    const base = (u.store_name || u.name || "").trim();
    const spec = (u.specialization_name || "").trim();
    if (spec && base) {
      if (base.startsWith(spec)) return base;
      return `${spec} ${base}`;
    }
    return base;
  }
  return (u.name || "").trim();
}

export function getDisplayInitial(u) {
  const name = getDisplayName(u);
  return name ? name.charAt(0) : "?";
}
